import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Selection } from '@swf/sports/components';
import Badges from '@swf/sports/components/Badges/Badges';

import type { MarketDynamicBanner } from '../../../../model/types';
import BadgeWithEventStatus from '../components/BadgeWithEventStatus';

import { TXTWCL_Request_A_Bet, TXTWCL_request_a_bet_selection } from './RequestABet.messages.json';
import styles from './RequestABet.scss';

const RequestABetDynamicBanner: React.FC<MarketDynamicBanner> = ({
  event,
  market,
  eventType,
  competition
}) => {
  const { formatMessage } = useRegulatoryIntl();
  const [runner] = market.runners;

  return (
    <>
      <BadgeWithEventStatus
        badge={
          <Badges
            iconName="rab"
            iconLabel={formatMessage(TXTWCL_request_a_bet_selection)}
            text={formatMessage(TXTWCL_Request_A_Bet)}
          />
        }
        startTime={event.eventStartTime}
        canTurnInPlay={market.turnInPlayEnabled}
        inPlay={market.inPlay}
      />
      <div className={styles.marketContainer}>
        <span className={styles.marketName}>{runner.runnerName}</span>
        <Selection
          competitionId={competition.competitionId}
          eventId={event.eventId}
          eventTypeId={eventType.eventTypeId}
          handicap={runner.handicap}
          key={runner.selectionId}
          legTypes={market.legTypes}
          marketId={market.marketId}
          marketStatus={market.marketStatus}
          odds={runner.winRunnerOdds}
          runnerResultType={runner.resultType}
          runnerStatus={runner.runnerStatus}
          selectionId={runner.selectionId}
          size="small"
          startTime={event.eventStartTime}
        />
      </div>
    </>
  );
};

export default RequestABetDynamicBanner;
